import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const MobileDevelopment = () => {
  return (
    <PageTemplate title="Mobile Development" subtitle="iOS, Android & Cross-Platform Apps" breadcrumb="Applications > Mobile Development">
      <div className="content-section"><h3>Mobile App Development</h3><p>Native and cross-platform mobile applications.</p></div>
    </PageTemplate>
  );
};

export default MobileDevelopment; 